import { AbstractReportPmsApiService } from "../abstract-report.service";
import { AccountBalances } from "../../../models/reports/daily-activity/account-balances.model";

/**
 * @class AccountBalancesPmsApiService
 * @extends {AbstractReportPmsApiService<AccountBalances>}
 */
export class AccountBalancesPmsApiService extends AbstractReportPmsApiService {
  /**
   * @type {string}
   * @protected
   */
  get urlPattern() {
    return super.urlPattern + "/daily-activity/account-balances";
  }

  /**
   * @param {Object.<string, *>} attributes
   * @returns {AccountBalances}
   * @protected
   */
  newModel(attributes, ...params) {
    return new AccountBalances(attributes);
  }

  getFooter(params = {}, property = null) {
    const url =
      this.url({ propertyId: property ? property.id : 0 }) + "-footer";

    return this.http
      .post(url, params, {
        headers: this.authHeaders,
      })
      .then(this.getDataExtractor())
      .catch(this.getErrorHandler());
  }

  /**
   * @param {Object.<string, *>} paginationData
   * @param {...*} params
   * @returns {PaginationCollection<M>}
   * @protected
   */
  newPaginationCollection(paginationData, ...params) {
    return {
      perPageOptions: [10, 25, 50, 100],
      perPage: paginationData.per_page,
      page: paginationData.current_page,
      total: paginationData.total,
      from: paginationData.from,
      to: paginationData.to,
      models: paginationData.data.map((attributes) =>
        this.newModel(attributes, ...params)
      ),
      pageTotalRow: paginationData.page_total_row,
      //allPagesTotalRow: paginationData.all_pages_total_row
    };
  }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/account-balances.service.js